import React from "react"

import {
    GridColDef,
} from "@mui/x-data-grid"

import { t } from "@lingui/macro"

import {
    AssetMatchBrand,
    OrderType,
    PaginatedResponse,
    SearchFilter,
} from "models"
import {
    PageSectionTitle,
    SbPaginatedDatagrid,
} from "components/commons"
import getCompatibleTableColumns from "./compatibleTableColumns"
import {FormControlLabel, Switch} from "@mui/material";
import {BrandProfileServices} from "../../../services/brand-profile.services";
import withUseRouter, {UseRouterParams} from "../../../services/router";
import {MatesComponent, MatesComponentState} from "../../mates-component";

interface CompatibleTableProps extends UseRouterParams
{
    handleCallback: (pagination: SearchFilter) => void
    data: PaginatedResponse<AssetMatchBrand>
    visible: boolean
    brandId: string
}
interface CompatibleTableState extends MatesComponentState
{
    pagination: SearchFilter,
    visible: boolean
}
class CompatibleTable extends React.Component<CompatibleTableProps, CompatibleTableState>
{
    private readonly columns: GridColDef[]
    private readonly matesComponent: MatesComponent<CompatibleTableProps, CompatibleTableState> = new MatesComponent(this)

    constructor(props: CompatibleTableProps)
    {
        super(props)
        this.columns = getCompatibleTableColumns()
        this.state = {
            ...this.matesComponent.setupState(),
            pagination: new SearchFilter(),
            visible: this.props.visible
        }
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        if(this.state.pagination.pageId !== pageId && this.state.pagination.pageSize !== pageSize) {
            this.setState(
                () => ({
                    pagination: {
                        ...this.state.pagination,
                        pageSize: pageSize,
                        pageId: pageId,
                    },
                }),
                () => this.props.handleCallback(this.state.pagination)
            )
        }
    }

    private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
        if(this.state.pagination.orderBy !== orderBy && this.state.pagination.orderType !== orderType) {
            this.setState(
                () => ({
                    pagination: {
                        pageSize: this.state.pagination.pageSize,
                        pageId: this.state.pagination.pageId,
                        orderBy: orderBy,
                        orderType: orderType,
                    },
                }),
                () => this.props.handleCallback(this.state.pagination)
            )
        }
    }

    private handleVisible = () => {
        BrandProfileServices.flagVisibility(this.props.brandId, this.visibilityCallback, this.matesComponent.onError)
    }

    private visibilityCallback = (response: any) => {
        if(response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.setState(() => ({
            visible: !this.state.visible
        }))
    }

    render()
    {
        return (
            <>
                <PageSectionTitle title={t({ id: "brand.compatibleTable.compatible-property", message: "Proprietà compatibili" })}>
                    <FormControlLabel control={<Switch onChange={this.handleVisible} checked={this.state.visible} color="success"/>}
                                      label={t({id: "brand-details.match-visible", message: "Autovisibilità match"})}
                                      sx={{color: "background.default"}}
                    />
                </PageSectionTitle>
                <SbPaginatedDatagrid
                    columns={this.columns}
                    data={this.props.data}
                    pagination={this.state.pagination}
                    onPaginationChanged={this.onPaginationChanged}
                    onSortChanged={this.onSortChanged}
                />
            </>
        )
    }
}

export default withUseRouter(CompatibleTable)
